import { render } from "./Agreement.vue?vue&type=template&id=4e356fe6&scoped=true&ts=true"
import script from "./Agreement.vue?vue&type=script&lang=ts"
export * from "./Agreement.vue?vue&type=script&lang=ts"

import "./Agreement.vue?vue&type=style&index=0&id=4e356fe6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e356fe6"]])

export default __exports__